import React, { useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";

//ESTA COLUMNA QUEDO INSERVIBLE, SE USA DIRECTAMENTE EN LA TABLA DEBIDO A QUE SE APLICA LOGICA DE REACT Y NO ES POSIBLE EN UN ARCHIVO JS

export const COLUMNSOBJETIVOS = [
  {
    accessorKey: "id",
  },
  {
    header: "Objetivo",
    accessorKey: "objetivo",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  // {
  //   header: "Fecha de carga",
  //   accessorKey: "fechaDeCarga",
  //   size: 50,
  //   minSize: 100,
  //   maxSize: 200,
  //   Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  // },
  {
    header: "Fecha de cumplimiento",
    accessorKey: "fechaDeCumplimiento",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Peso %",
    accessorKey: "peso",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Resultados Claves",
    accessorKey: "indicador",
    size: 50,
    minSize: 150,
    maxSize: 200,
    Cell: ({ row }) => (
      <VerResultadosButton row={row} />
    ),
  },
  {
    header: "Estado de avance",
    accessorKey: "status",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "% de Avance",
    accessorKey: "porcentajeAvance",
    size: 50,
    minSize: 150,
    maxSize: 200,
    // Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    // Cell: ({ row }) => (
    //   <Button onClick={() => handleAbrirModal(row.original.id)} variant="contained" size="small">Ver avances</Button>
    // ),
  },
  // {
  //   header: "Estado",
  //   accessorKey: "estado",
  //   size: 50,
  //   minSize: 100,
  //   maxSize: 200,
  //   Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  // },
]



const VerResultadosButton = ({ row }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const resultadosClaves = {
    indicador: row.original.indicador,
    indicador2: row.original.indicador2,
    indicador3: row.original.indicador3,
    indicador4: row.original.indicador4,
    indicador5: row.original.indicador5,
  };

  return (
    <>
      <Button onClick={handleOpen} variant="contained" size="small">Ver Resultados</Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Resultados Claves:</DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
            {Object.keys(resultadosClaves).map((key, index) => (
              <Typography key={index} variant="body1" style={{ marginBottom: '8px', textAlign: 'center' }}>
                <strong>{`Resultado ${index + 1}:`}</strong> {resultadosClaves[key] || ""}
              </Typography>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

